module.exports = __webpack_public_path__ + "static/souk-9fd07ab4f3142ed29ca55b9d4ab4ad05.jpg";